import React, { useState } from 'react';
import axios from 'axios';
import { Droplet, Flame, Plug, Plus } from 'lucide-react';
import { toast } from 'sonner';
import UtilityDetailDialog from '../UtilityDetailDialog';
import { API } from './utils';

export default function UtilitiesSection({ property, propertyId, onUtilityUpdated }) {
  const [selectedUtility, setSelectedUtility] = useState(null);
  const [utilityDialogOpen, setUtilityDialogOpen] = useState(false);

  const openUtility = (utilityType = null) => {
    setSelectedUtility(utilityType);
    setUtilityDialogOpen(true);
  };

  const handleUpdateUtility = async (utilityType, updatedData) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/properties/${propertyId}`, updatedData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Utility information updated');
      setUtilityDialogOpen(false);
      await onUtilityUpdated();
    } catch (error) {
      toast.error('Failed to update utility information');
    }
  };

  const hasWater = property.water_meter || property.water_supplier || property.water_meter_start_reading || property.water_meter_latest_reading;
  const hasGas = property.gas_meter || property.gas_supplier || property.gas_meter_start_reading || property.gas_meter_latest_reading;
  const hasElectric = property.electric_meter || property.electric_supplier || property.electric_meter_start_reading || property.electric_meter_latest_reading;

  return (
    <div className="utilities-section">
      <div className="section-header-with-action">
        <h3 className="section-title-simple">
          <Plug size={20} />
          Utilities & Meters
        </h3>
      </div>

      <div className="utilities-grid-simple">
        {hasWater && (
          <div className="utility-item-card clickable-utility" onClick={() => openUtility('water')}>
            <div className="utility-card-header">
              <Droplet size={24} style={{ color: '#48cae4' }} />
              <div className="utility-card-title">Water</div>
            </div>
            <div className="utility-card-info">
              <div className="utility-info-row">
                <span className="utility-info-label">Meter:</span>
                <span className="utility-info-text">{property.water_meter || 'Not set'}</span>
              </div>
              <div className="utility-info-row">
                <span className="utility-info-label">Supplier:</span>
                <span className="utility-info-text">{property.water_supplier || 'Not set'}</span>
              </div>
            </div>
          </div>
        )}

        {hasGas && (
          <div className="utility-item-card clickable-utility" onClick={() => openUtility('gas')}>
            <div className="utility-card-header">
              <Flame size={24} style={{ color: '#f59e0b' }} />
              <div className="utility-card-title">Gas</div>
            </div>
            <div className="utility-card-info">
              <div className="utility-info-row">
                <span className="utility-info-label">Meter:</span>
                <span className="utility-info-text">{property.gas_meter || 'Not set'}</span>
              </div>
              <div className="utility-info-row">
                <span className="utility-info-label">Supplier:</span>
                <span className="utility-info-text">{property.gas_supplier || 'Not set'}</span>
              </div>
            </div>
          </div>
        )}

        {hasElectric && (
          <div className="utility-item-card clickable-utility" onClick={() => openUtility('electric')}>
            <div className="utility-card-header">
              <Plug size={24} style={{ color: '#667eea' }} />
              <div className="utility-card-title">Electric</div>
            </div>
            <div className="utility-card-info">
              <div className="utility-info-row">
                <span className="utility-info-label">Meter:</span>
                <span className="utility-info-text">{property.electric_meter || 'Not set'}</span>
              </div>
              <div className="utility-info-row">
                <span className="utility-info-label">Supplier:</span>
                <span className="utility-info-text">{property.electric_supplier || 'Not set'}</span>
              </div>
            </div>
          </div>
        )}

        <div className="utility-add-card" onClick={() => openUtility(null)}>
          <Plus size={32} style={{ color: 'var(--primary)' }} />
          <div className="utility-add-text">Add Utility</div>
        </div>
      </div>

      <UtilityDetailDialog
        open={utilityDialogOpen}
        onOpenChange={setUtilityDialogOpen}
        utilityType={selectedUtility}
        utilityData={property}
        onUpdate={handleUpdateUtility}
      />
    </div>
  );
}
